import { render, staticRenderFns } from "./AuditTrailView.vue?vue&type=template&id=6bd9992a"
import script from "./AuditTrailView.vue?vue&type=script&lang=js"
export * from "./AuditTrailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd9992a')) {
      api.createRecord('6bd9992a', component.options)
    } else {
      api.reload('6bd9992a', component.options)
    }
    module.hot.accept("./AuditTrailView.vue?vue&type=template&id=6bd9992a", function () {
      api.rerender('6bd9992a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audittrail/AuditTrailView.vue"
export default component.exports